export const IB_TESTES = ['ib'];
const isSat = (type: string) => IB_TESTES.includes(type);

// {
//     "total": 12,
//     "studies_in_language_and_literature": null,
//     "language_acquisition": null,
//     "individuals_and_societies": null,
//     "experimental_science": null,
//     "mathematics": null,
//     "the_arts": null
// }

interface StandardItem {
  type: string;
  study_in_language_and_literature: number;
  language_acquisition: number;
  individuals_and_societies: number;
  experimental_science: number;
  mathematics: number;
  the_arts: number;
}

export default class IbSubjectTestConverter {
  static is = isSat;
  static isValid = (item: StandardItem) => {
    return (
      item.type === 'ib' &&
      item.study_in_language_and_literature > 0 &&
      item.language_acquisition > 0 &&
      item.individuals_and_societies > 0 &&
      item.experimental_science > 0 &&
      item.mathematics > 0 &&
      item.the_arts > 0
    );
  };

  static toArray(resume: Record<string, any>) {
    return IB_TESTES.map((type) => {
      const target = resume['ib_subject_test'];
      if (!target) return null;
      return { type, ...target };
    }).filter(Boolean);
  }

  static toValidArray(resume: Record<string, any>) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }

  static toObject(items: StandardItem[]) {
    const resume = {};
    items.forEach((item) => {
      if (this.is(item.type)) {
        resume['ib_subject_test'] = item;
      }
    });
    return resume;
  }

  static toObjectV3(obj: Record<string, any>) {
    const resume = {};
    resume['ib_subject_test'] = {
      type: 'ib',
      ...obj,
    };
    return resume;
  }

  static defaults() {
    return {
      ib_subject_test: {
        type: 'ib',
        study_in_language_and_literature: 0,
        language_acquisition: 0,
        individuals_and_societies: 0,
        experimental_science: 0,
        mathematics: 0,
        the_arts: 0,
      },
    };
  }
}
